import { createSelector } from 'reselect'
import { path } from 'ramda'
import { NAMESPACE } from './constants'

const getState = (state: any) => state

export const walletTransferState = createSelector(getState, s => path([NAMESPACE], s))
